import { FormLabel, FormLabelProps } from '@masterplandev/ui'

export function PollLabel(props: FormLabelProps) {
  return <FormLabel fontWeight="medium" fontSize="md" mb="4" {...props} />
}
